import React, {useEffect, useState} from 'react';
import { v4 } from 'uuid';
import { Button, Modal, Table} from 'react-bootstrap';
import {updatePreference} from "../../API/parser"
//import {updateAnnotations} from "../../API/annotatorApi"
import {getToken} from "../../Utils/Common";

function PositionPickerComponent(props) {
    const [positionPreference, setPositionPreference] = useState([])




    //let annotationData = props.annotationData
   let url = process.env.REACT_APP_BACKEND_API_URI
//
    async function updateToServer(args){
            let apiPromises = args.map((body) =>
               fetch(`${url}annotator/update_annotations`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)})
                    .then((response) => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok');
                      }
                      return response.json();
                    })
                    .catch((error) => {
                      // Handle any errors here
                      console.error('Error:', error);
                    })
            );
            return apiPromises
    }


    async function updateHTML(html, oldID, newID){
        // Create a DOMParser instance
        const parser = new DOMParser();

        // Parse the HTML string
        let doc = parser.parseFromString(html, 'text/html');

        // Find the mark element
        let markElement = doc.getElementById(oldID);

        // Update the id attribute
        if(markElement){
            markElement.setAttribute('id', newID);
        } else {
            console.log("element not existed")
        }

        // Convert the updated DOM back to an HTML string
        return doc.documentElement.outerHTML;

    }


   async function createUpdates(filteredAnnotationsByRowId, targetLvPositionAttributes, pText) {
          let annots = [];
          let html = pText


          for (let item = 0; item < filteredAnnotationsByRowId.length; item++) {
            let oldID = filteredAnnotationsByRowId[item].unique_id;
            let newID = v4();

            // Create a new object and copy attributes from the original object
            let updatedAnnotation = {
              ...filteredAnnotationsByRowId[item],
              rowId: targetLvPositionAttributes.rowId,
              ord: targetLvPositionAttributes.ord,
              short_text: targetLvPositionAttributes.short_text,
              unique_id: newID,
            };

            html = await updateHTML(html, oldID, newID);

            annots.push({ unique_id: newID, lv_id: targetLvPositionAttributes.lv_id, Annotation: updatedAnnotation });
          }
          return { targetAnnotations: annots, targetLvDocument: html };
    }


    async function updateHistory(identifier, pText, positionMatches, matchedAnnotationData) {
          let requests = []
          let annotations = [];
          let documents = [];

          if (matchedAnnotationData){
              annotations = matchedAnnotationData.annotations
              documents =  matchedAnnotationData.lv_document
          }
          console.log(documents)
          let prefferedAnnotations = annotations.filter((item) => item.rowId === identifier); // annotations from preferred position matches

          for(let each of positionMatches){
             //get lv position attributes from matches
             let targetLvPositionAttributes = {}
             if(annotations.length > 0){

                targetLvPositionAttributes.lv_id = each.row_id.split('=')[0]
                targetLvPositionAttributes.rowId = each.row_id
                targetLvPositionAttributes.ord = each.ref
                let keyToCheck = 'hinweis'
                if (Object.prototype.hasOwnProperty.call(each, keyToCheck)) {
                        targetLvPositionAttributes.short_text = each.hinweis

                 } else {
                        targetLvPositionAttributes.short_text = 'null'
                }
             }

             let targetPtext = pText

             let target  = await createUpdates(prefferedAnnotations, targetLvPositionAttributes, targetPtext)

            requests.push({"annotations": target.targetAnnotations,
                               "rowId": each.row_id,
                               "pText": target.targetLvDocument,
                               "token": getToken()})
          }

          console.log(requests, "all created data")
          let allPromises = await updateToServer(requests)

          // Wait for all promises to resolve using Promise.all
          Promise.all(allPromises)
              .then(async(results) => {
                // Process the results from all API calls
                console.log('All API calls completed:', results)
                let filtered = positionMatches.filter(item => item.row_id === identifier);

                await updatePreference(identifier.split('=')[0],
                                        identifier,
                                        filtered[0].ltext_hashvalue,
                                        pText)

                //window.location.reload();

              })
              .catch((error) => {
                // Handle errors if any of the promises are rejected
                console.error('One or more API calls failed:', error);
              });

    }
    useEffect(() => {

    const positionMatches = props.positionMatches
    const matchedAnnotationData = props.matchedAnnotationData
    let texts = matchedAnnotationData.lv_document
    console.log(positionMatches)
    let positions;
    if (texts){
        positions = texts.map((o) => (
            <tr key={o.id} className={o.id == props.selectedPreference ? 'bg-info' : ''}>
                <td>{o.id.split('=')[0]}</td>
                <td> <p id={o.id} dangerouslySetInnerHTML={{__html: o.pText}} /> </td>
                <td> <Button id={o.id} onClick={async () => await updateHistory(o.id,
                                                                    o.pText,
                                                                    positionMatches,
                                                                    matchedAnnotationData)}> Select </Button> </td>

            </tr>
            ));
            }
    setPositionPreference(positions)
    }, [props.positionMatches]);

    return (
        <>
        <div>
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                Centered
                animation={true}
                backdrop="static"
                className={'positionXLModal'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">Select Position</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Table striped bordered hover>
      <thead>
        <tr>
          <th>LVID</th>
          <th>Position</th>
          <th>Preference</th>
        </tr>
      </thead>
      <tbody>
        {positionPreference}
      </tbody>
    </Table>
                </Modal.Body>
                <Modal.Footer>
                    &nbsp; &nbsp;
                    <Button size="lg" variant="outline-dark" onClick={props.onHide}>
                        {' '}
                        &nbsp; Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
        </>
    );
}

export default PositionPickerComponent;